/**
 * 题目 api
 * 题目 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The PassageSequencingQuestionVo model module.
   * @module drill/model/PassageSequencingQuestionVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PassageSequencingQuestionVo</code>.
   * @alias module:drill/model/PassageSequencingQuestionVo
   * @class
   * @param text {String} 题干
   * @param optionList {Array.<String>} 选项列表
   * @param correctAnswer {Array.<String>} 正确排序答案
   */
  var exports = function(text, optionList, correctAnswer) {
    var _this = this;

    _this['text'] = text;

    _this['optionList'] = optionList;
    _this['correctAnswer'] = correctAnswer;
  };

  /**
   * Constructs a <code>PassageSequencingQuestionVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:drill/model/PassageSequencingQuestionVo} obj Optional instance to populate.
   * @return {module:drill/model/PassageSequencingQuestionVo} The populated <code>PassageSequencingQuestionVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'text')) {
        obj['text'] = ApiClient.convertToType(data['text'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'explanation')) {
        obj['explanation'] = ApiClient.convertToType(data['explanation'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'optionList')) {
        obj['optionList'] = ApiClient.convertToType(data['optionList'], ['String']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'correctAnswer')) {
        obj['correctAnswer'] = ApiClient.convertToType(data['correctAnswer'], ['String']);
      }
    }
    return obj;
  }

  /**
   * 题干
   * @member {String} text
   */
  exports.prototype['text'] = undefined;
  /**
   * 解析
   * @member {String} explanation
   */
  exports.prototype['explanation'] = undefined;
  /**
   * 选项列表
   * @member {Array.<String>} optionList
   */
  exports.prototype['optionList'] = undefined;
  /**
   * 正确排序答案
   * @member {Array.<String>} correctAnswer
   */
  exports.prototype['correctAnswer'] = undefined;



  export default exports;
;


